import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select
} from "@material-ui/core";

export type SelectTableFilterProps = {
  filter: TableFilterSelectType;
  onFilterChange: (filterValue: string) => void;
};

export type TableFilterSelectType = {
  type: "select";
  name: string;
  label: string;
  options: {
    value: string;
    label: string;
    default?: boolean;
  }[];
};

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

export const SelectTableFilter = ({
  filter,
  onFilterChange
}: SelectTableFilterProps) => {
  const classes = useStyles();
  const defaultValue = filter.options.find(option => option.default);
  const [value, setValue] = useState(defaultValue ? defaultValue.value : "");

  return (
    <FormControl className={classes.formControl}>
      <InputLabel id={`select-${filter.name}-label`}>{filter.label}</InputLabel>
      <Select
        id={`select-${filter.name}-label`}
        value={value}
        onChange={event => {
          setValue(event.target.value as string);
          onFilterChange(event.target.value as string);
        }}
      >
        {filter.options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
